import { render, staticRenderFns } from "./AcaoForm.vue?vue&type=template&id=bea988ee&scoped=true"
import script from "./AcaoForm.vue?vue&type=script&lang=js"
export * from "./AcaoForm.vue?vue&type=script&lang=js"
import style0 from "./AcaoForm.vue?vue&type=style&index=0&id=bea988ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea988ee",
  null
  
)

export default component.exports